<div class="flex h-screen overflow-hidden">
  <div
    class="h-full py-8 bg-sidebar border-r shadow-md transition-all duration-300 flex-shrink-0"
    [class.w-64]="sidebarVisible"
    [class.w-0]="!sidebarVisible"
  >
    @if (sidebarVisible) {
      <app-sidebar></app-sidebar>
    }
  </div>

  <div class="flex flex-col flex-1 h-full min-w-0">
    <app-header (toggleSidebar)="toggleSidebar()"></app-header>

    <main class="flex-1 px-8 py-7 overflow-auto">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>